import { useMutation } from '@apollo/client';
import { Grid } from '@mui/material';
import MultistepForm from 'app/components/MultistepForm';
import { Formik } from 'formik';

import { isEmpty, omitBy, pick } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { validateForm } from 'utils/FormErrorHelper';
import { IOSettingsInformation } from './IOSettingsInformation';
import { ioSettingsValidationSchema } from './validation';
import { actions as AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';

import EDIT_MUTATION from 'gql/mutations/InternationalOffice/editIOSettings.gql';

interface Props {
  closeHandler: Function;
  setDisabledCancel: Function;
  settings?: any;
}

export function IOSettingsModal(props: Props) {
  const [submitting, setSubmitting] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [editIOSettings] = useMutation(EDIT_MUTATION);

  const initialValues = () => {
    return props.settings
      ? {
          ...pick(props.settings, ['year', 'semesterType', 'examRegistration'])
        }
      : {};
  };

  const handleSaveClick = async values => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    try {
      let saveBody: any = {
        ...values
      };

      await editIOSettings({
        variables: { data: omitBy(saveBody, v => v === null || v === '') },
        refetchQueries: ['GetIOSettings']
      });
      dispatch(
        AlertActions.success(
          t(translations.pages.internationalOffice.courses.alerts.success.updatedCourse())
        )
      );
    } catch (err) {
      dispatch(
        AlertActions.error(
          t(translations.pages.internationalOffice.courses.alerts.error.updatingCourse())
        )
      );
    } finally {
      props.closeHandler();
    }
  };

  const steps = ['Settings '];

  const SettingsModalStep = ({ step }) => {
    switch (step) {
      case 0:
        return <IOSettingsInformation />;
      default:
        return null;
    }
  };

  return (
    <Grid item className="ioSettingsModal">
      <Formik
        isInitialValid={!!props.settings && !isEmpty(props.settings)}
        initialValues={initialValues()}
        onSubmit={values => handleSaveClick(values)}
        validationSchema={ioSettingsValidationSchema(t)}
        validate={values => {
          return validateForm(values, ioSettingsValidationSchema(t), dispatch);
        }}
      >
        <MultistepForm
          submitting={submitting}
          steps={steps}
          onCancel={props.closeHandler}
          hideStepper
        >
          {activeStep => (
            <Grid container>
              <SettingsModalStep step={activeStep} />
            </Grid>
          )}
        </MultistepForm>
      </Formik>
    </Grid>
  );
}
